import { render, staticRenderFns } from "./_template-evaluation-comment.vue?vue&type=template&id=89e30156&"
import script from "./_template-evaluation-comment.vue?vue&type=script&lang=js&"
export * from "./_template-evaluation-comment.vue?vue&type=script&lang=js&"
import style0 from "./_template-evaluation-comment.vue?vue&type=style&index=0&id=89e30156&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports